import React from 'react';
import AuthLayout from "../layout";
import {changePass, resetPassword} from "../../util/APIUtils";
import {error, success} from "../../util/toast";
import { DEFAULT_REDIRECT_URI } from "../../constants";
import { useQuery } from "../../common/hooks/useQuery";
import { useYupValidationForm } from "../../common/hooks/useYupValidationForm";
import * as yup from "yup";
import { Redirect } from "react-router";
import logo from "../../assets/img/logoVinet.svg";
import {Link} from "react-router-dom";
import {useLingui} from "@lingui/react";

const validationSchema = yup.object({
  newPassword: yup.string().trim().min(6, 'Mật khẩu tối thiểu 6 ký tự'),
  retypePassword: yup.string().oneOf([ yup.ref('newPassword'), null ], "Mật khẩu không khớp!")
});

const ChangePassword = () => {
  const {i18n} = useLingui();
  const { register, handleSubmit, formState: { errors } } = useYupValidationForm(validationSchema);
  const query = useQuery();
  const key = query.get('key');
  const onSubmit = data => {
    let reqData;
    if (key) {
      reqData = {
        key,
        newPassword: data.newPassword
      }
      resetPassword(reqData).then(rs => {
        window.location.href = `/`;
      }).catch(err => {
        console.log(err)
        error((err ? err.detail : "") || 'Oops! Something went wrong. Please try again!')
      })
    } else {
      reqData = {
        newPassword: data.newPassword
      }
      changePass(reqData)
        .then(() => {
          success('Đổi mật khẩu thành công')
          setTimeout(() => {
            window.location.href = DEFAULT_REDIRECT_URI;
          },3700)
        }).catch(err => {
        error((err && err.detail) || 'Oops! Something went wrong. Please try again!')
      });
    }
  };

  return (

    <div>
      <div className="pt-5 pl-10 w-screen">
        <div className="w-40">
          <a href={DEFAULT_REDIRECT_URI}>
            <img src={logo} className="w-full mx-auto" alt="Logo VINET" />
          </a>
        </div>
      </div>
      <div>
        <div className="text-center font-bold text-4xl text-[#007DC5]">
          {i18n._('Đặt lại mật khẩu')}
        </div>
        <div>
          <form className={'flex flex-col w-96 mx-auto mt-10'} onSubmit={handleSubmit(onSubmit)}>
            <div className={'mx-10 py-1 lg:py-3'}>
              <div
                className={`font-bold mr-2 mt-1`}>
                Mật khẩu mới
              </div>
              <input type={"password"}
                     className={`w-full py-2 px-5 rounded-xl focus:ring outline-none border-2 ${errors.newPassword ? 'border-red-500' : 'border-gray-300'}`}
                     placeholder={'Mật khẩu mới'} {...register('newPassword')}/>
              <div
                className={`text-right text-red-500 font-bold mr-2 mt-1 text-xs w-full`}>
                {errors.newPassword?.message ? errors.newPassword.message : <>&nbsp;</>}
              </div>
            </div>
            <div className={'mx-10 py-1 lg:py-3'}>
              <div
                className={`font-bold mr-2 mt-1`}>
                Nhập lại mật khẩu mới
              </div>
              <input type={"password"}
                     className={`w-full py-2 px-5 rounded-xl focus:ring outline-none border-2 ${errors.retypePassword ? 'border-red-500' : 'border-gray-300'}`}
                     placeholder={'Nhập lại mật khẩu mới'}
                     {...register('retypePassword')}/>
              <div className={'text-right text-red-500 font-bold mr-2 mt-1 text-xs'}>
                {errors.retypePassword?.message ? errors.retypePassword.message : <>&nbsp;</>}
              </div>
            </div>
            <div className={'mx-auto py-5 md:py-2 lg:py-5'}>
              <button className={'mx-2 text-white bg-[#007DC5] py-2 w-36 rounded-lg'} type={"submit"}>
                Xác nhận
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default ChangePassword
